import React, {Component} from 'react';
import {Redirect, Route} from "react-router-dom";

import GeneralHeader from '../Generals/GeneralHeader';
import GeneralFooter from '../Generals/GeneralFooter';
import ForgotPasswordContainer from '../../containers/ForgotPasswordContainer';
import LoginContainer from '../../containers/Auth/LoginContainer';
import SignupContainer from '../../containers/SignupContainer';

/**
 *
 */
class Authorization extends Component {
    constructor(props){
        super(props);

        this.state = {
            browser: "Other"
        }
    }

    componentDidMount(){
        let browser = "Other";
        let ua = navigator.userAgent;
        window.localStorage.clear();

        if(ua.indexOf("Edge") > -1){
            browser = "Edge";
        }else if(ua.indexOf("IE") > -1) {
            browser = "IE";
        }else if(ua.indexOf("Chrome") > -1){
                browser = "Chrome";

        }else if(ua.indexOf("Safari") > -1){
            browser = "Safari";
        }else if(ua.indexOf("Firefox") > -1){
            browser = "Firefox";
        }

        this.setState({browser: browser});



    }

    render(){
        let {pathname} = this.props;
        let {browser} = this.state;

            return (
                <div>

                    {["Chrome", "Firefox"].indexOf(this.state.browser) === -1 ?
                        <h1 className="browser-error">
                            This browser is unsupported, and some features may not work.
                            For this reason, it's advised that you use <a href="https://www.google.com/chrome/"
                                                                          target="_blank">Google Chrome</a>
                            or <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Mozilla Firefox</a>
                        </h1>
                        :
                        <div>
                            {
                                pathname.indexOf('login') === -1 &&
                                pathname.indexOf('signup') === -1 &&
                                pathname.indexOf('forgot-password') === -1 &&
                                pathname.indexOf('configure-password') === -1 &&
                                <Route
                                    path="/"
                                    render={() => (
                                        <Redirect
                                            to="/login"
                                        />
                                    )}
                                />
                            }
                            <Route
                                path='/login'
                                component={LoginContainer}
                                browser={browser}
                            />
                            <Route
                                path='/signup'
                                component={SignupContainer}
                                browser={browser}
                            />


                            <Route
                                path='/configure-password/:access_token'
                                render={(props) => <ForgotPasswordContainer {...props} />}
                            />

                            <Route
                                path='/forgot-password/:access_token'
                                render={(props) => <ForgotPasswordContainer {...props} />}
                            />
                            <Route
                                path='/forgot-password'
                                render={(props) => <ForgotPasswordContainer {...props} />}
                            />
                        </div>
                    }

                </div>
            )
    }
}


export default Authorization;


// WEBPACK FOOTER //
// ./src/components/Auth/Autorization.js